import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

const AgeGradeHero = () => {
  const heroRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReducedMotion) return;

    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    tl.from(hero.querySelector("h1"), { opacity: 0, y: 40, duration: 1.2 })
      .from(
        hero.querySelector("p"),
        { opacity: 0, y: 20, duration: 1 },
        "-=0.8"
      )
      .from(
        hero.querySelector(".divider"),
        {
          opacity: 0,
          width: 0,
          duration: 1,
          ease: "power2.inOut",
        },
        "-=0.6"
      );
  }, []);

  return (
    <section
      ref={heroRef}
      className="relative overflow-hidden bg-stone-50 py-24 text-center md:py-32"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-stone-50 to-white opacity-50"></div>
      <div className="relative mx-auto max-w-4xl px-6">
        <h1 className="font-serif text-4xl font-bold tracking-tight text-nature-green-dark md:text-6xl">
          Age Grades System
        </h1>
        <p className="mx-auto mt-6 max-w-2xl font-poppins text-lg text-gray-700 md:text-xl">
          The pillar of our unity, responsibility, and shared identity. Discover
          the tradition that builds our future.
        </p>
        <div className="mt-10 flex justify-center">
          <div className="divider h-1 w-24 rounded-full bg-amber-400"></div>
        </div>
      </div>
    </section>
  );
};

export default AgeGradeHero;
